export default {
  opponentRank: {
    title: "Opponent Rank",
    tabs: {
      byRanking: "By Ranking",
      allRankings: "All Rankings",
    },
    empty: {
      title: "No opponent rankings available",
    },
  },
};